<template>
	<!-- 聊天:按钮操作项 -->
	<div>
		<buttonList :buttonList="list" butWidth="200px" v-if="!isFold"></buttonList>
		<iconList :list="list" v-else></iconList>
		<turnIntoClue
			:id="id"
			:nickname="nickname"
			:messengerUserId="messengerUserId"
			:turn_visible.sync="visable"
			v-bind="$attrs"
		></turnIntoClue>
		<assignFollowUp
			:summaryId="id"
			:visible.sync="assign_visible"
			:messengerUserId="messengerUserId"
			:type="0"
			v-bind="$attrs"
		>
		</assignFollowUp>
	</div>
</template>
<script>
import iconList from '@/components/chat/components/iconList.vue';
import buttonList from '@/components/chat/buttonList.vue';
import turnIntoClue from '@/components/chat/components/turn-into-clue.vue';
import assignFollowUp from '@/components/chat/components/assign-follow-up.vue';

export default {
	props: {
		isFold: {
			type: Boolean,
			default: false,
		},
		id: { type: String },
		nickname: {
			type: String,
		},
		messengerUserId: null,
	},
	data() {
		let that = this;
		return {
			assign_visible: false,
			visable: false,
			list: [
				{
					text: '对话分配',
					imgsrc: require('@/assets/chat/chat_a.png'),
					onClick: () => {
						that.assign_visible = true;
					},
					isShow: () => {
						return that.$route.name !== 'liveChat';
					},
				},
				{
					text: '转为线索',
					imgsrc: require('@/assets/chat/to_clue.png'),
					onClick: () => {
						that.visable = true;
					},
				},
			],
		};
	},
	components: { buttonList, iconList, turnIntoClue, assignFollowUp },

	computed: {},

	methods: {},
};
</script>

<style lang="scss" scoped></style>
